import { render, staticRenderFns } from "./confirmDialog.vue?vue&type=template&id=6f728b13&scoped=true&"
import script from "./confirmDialog.vue?vue&type=script&lang=js&"
export * from "./confirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./confirmDialog.vue?vue&type=style&index=0&id=6f728b13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f728b13",
  null
  
)

export default component.exports